import React from 'react';
import styles from './PrintTasksTable.module.scss';
import { TaskRowViewModel } from '../utils/TaskPrintMapper';
import { PrintTasksRow } from '../PrintTasksRow/PrintTasksRow';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationDot } from '@fortawesome/pro-regular-svg-icons';

interface PrintTasksTableProps {
    groups: {
        locationName: string;
        rows: TaskRowViewModel[];
    }[];
    showLocationHeaders?: boolean;
}

export const PrintTasksTable: React.FC<PrintTasksTableProps> = ({ groups, showLocationHeaders = true }) => {
    return (
        <table className={styles.table}>
            <thead>
                <tr>
                    <th className={styles.colPet}>PET</th>
                    <th className={styles.colTask}>TASK</th>
                    <th className={styles.colNotes}>NOTES</th>
                    <th className={styles.colTime}>TIME</th>
                    <th className={styles.colStaff}>STAFF</th>
                </tr>
            </thead>

            <tbody>
                {groups.map(group => (
                    <React.Fragment key={group.locationName}>
                        {showLocationHeaders && (
                            <tr className={styles.locationRow}>
                                <td
                                    className={styles.locationCell}
                                    colSpan={5}
                                >
                                    <FontAwesomeIcon
                                        icon={faLocationDot}
                                        className={styles.locationIcon}
                                    />

                                    <span className={styles.locationText}>{group.locationName}</span>
                                </td>
                            </tr>
                        )}

                        {group.rows.map(row => (
                            <PrintTasksRow
                                key={row.id}
                                row={row}
                            />
                        ))}
                    </React.Fragment>
                ))}
            </tbody>
        </table>
    );
};

export default PrintTasksTable;
